import { Badge, Tag } from '@arco-design/web-react';
import React from 'react';

export function DisplayOption({
  options,
  value = 1,
  type = 'badge',
}: {
  value: number;
  type?: 'badge' | 'tag';
  options: {
    label: string;
    value: number;
    color: string;
  }[];
}) {
  const item = options.find((v) => v.value === value);
  if (!item) {
    return <div>-</div>;
  }
  if (type === 'tag') {
    return <Tag color={item.color}>{item.label}</Tag>;
  }
  return <Badge color={item.color} text={item.label} />;
}
